var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SearchStatus } from '@/overmind/search/state';
import SearchNotFoundHeader from 'modules/search/components/SearchNotFoundHeader.vue';
import { json } from 'overmind';
let FormationOfDecisionMakers = class FormationOfDecisionMakers extends Vue {
    constructor() {
        super(...arguments);
        this.keys = this.formationOfDecisionMakers.map(item => this.handlerKey(item));
        this.values = this.formationOfDecisionMakers.map(item => {
            return {
                name: this.handlerKey(item),
                y: item.doc_count,
            };
        });
        this.chartOptions = {
            chart: {
                type: 'column',
            },
            title: {
                text: '',
            },
            xAxis: {
                title: '',
                categories: json(this.keys),
            },
            yAxis: {
                title: '',
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                column: {
                    pointPadding: -0.2,
                },
            },
            tooltip: {
                headerFormat: '<span>{series.name}</span>',
                pointFormat: '<span style="font-weight: bold">{point.name}</span>: {point.y}',
            },
            series: [
                {
                    name: '',
                    // @ts-ignore TS2349: property inexistent
                    data: json(this.values),
                    color: '#339FFF',
                },
            ],
            credits: false,
        };
    }
    formationOfDecisionMakersChanged(current, old) {
        this.chartOptions.xAxis.categories = current.map(item => item.key);
        this.chartOptions.series[0].data = current.map(item => {
            return {
                name: this.handlerKey(item),
                y: item.doc_count,
            };
        });
    }
    handlerKey(value) {
        const newKey = value.key[0].toUpperCase() + value.key.slice(1).toLowerCase();
        return newKey.replace(/_/g, ' ');
    }
};
__decorate([
    Prop({ default: SearchStatus.NOT_RECEIVED })
], FormationOfDecisionMakers.prototype, "createSearchState", void 0);
__decorate([
    Prop({ default: () => [] })
], FormationOfDecisionMakers.prototype, "formationOfDecisionMakers", void 0);
__decorate([
    Prop({ default: 1 })
], FormationOfDecisionMakers.prototype, "page", void 0);
__decorate([
    Watch('formationOfDecisionMakers')
], FormationOfDecisionMakers.prototype, "formationOfDecisionMakersChanged", null);
FormationOfDecisionMakers = __decorate([
    Component({
        components: {
            SearchNotFoundHeader,
        },
    })
], FormationOfDecisionMakers);
export default FormationOfDecisionMakers;
